import React, { useCallback, useContext, useEffect, useMemo, useRef, } from 'react';
import noop from 'lodash/noop';
import ModalContainer from '../modal-container/ModalContainer';
import Modal from '../modal/Modal';
import ModalContext from './ModalContext';
const ModalProvider = (props) => {
    const { location: contextLocation } = useContext(ModalContext);
    const { location = contextLocation, children, getContainer } = props;
    const ref = useRef(null);
    const prepareToOpen = useMemo(() => [], []);
    const open = useCallback((modalProps) => {
        const container = ref.current;
        if (container) {
            const close = async (destroy) => {
                const { onClose = noop } = modalProps;
                if ((await onClose()) !== false) {
                    if (destroy) {
                        container.close({ ...modalProps, destroyOnClose: true });
                    }
                    else {
                        container.close(modalProps);
                    }
                }
            };
            const show = () => {
                container.open(modalProps);
            };
            const update = newProps => {
                container.update({ ...modalProps, ...newProps });
            };
            modalProps = {
                close,
                update,
                ...Modal.defaultProps,
                ...modalProps,
            };
            container.open(modalProps);
            return {
                close,
                open: show,
                update,
            };
        }
        prepareToOpen.push(modalProps);
    }, []);
    useEffect(() => {
        if (ref.current) {
            prepareToOpen.forEach(prepare => open(prepare));
        }
    }, [ref, open]);
    const context = {
        open,
        location,
    };
    return (React.createElement(ModalContext.Provider, { value: context },
        React.createElement(ModalContainer, { ref: ref, location: location, getContainer: getContainer }),
        children));
};
export const useModal = () => {
    return useContext(ModalContext);
};
export const injectModal = Target => {
    const Hoc = props => {
        const modal = useModal();
        return React.createElement(Target, Object.assign({}, props, { Modal: modal }));
    };
    Hoc.displayName = `${Target.displayName || Target.name || 'Anonymous'}-with-inject-modal`;
    return Hoc;
};
ModalProvider.displayName = 'ModalProvider';
ModalProvider.useModal = useModal;
ModalProvider.injectModal = injectModal;
export default ModalProvider;
